import React from 'react';
import { Headline7 } from '../../typography';
import {
  ErrorContainer,
  TextError,
} from './styled.errorValidation';
import { AlertOctagon } from '../../icons/AlertOctagon';

export function ErrorValidation ({ message }) {
  return (
    <Headline7>
      <ErrorContainer>
        <AlertOctagon />
        <TextError>{message}</TextError>
      </ErrorContainer>
    </Headline7>
  );
}
